import React from "react";
import { useRecoilState } from "recoil";
import { carrierStateAppointed } from "../atom/atoms";
import { ICarrierStateAppointed } from "../types";
import CarrierStateAppointedForm from "./CarrierStateAppointedForm";

const CarrierStateAppointed = () => {
  const [stateAppointeds] = useRecoilState<Array<ICarrierStateAppointed>[]>(
    carrierStateAppointed
  );
  return (
    <div className="mt-2 bg-white box-shadow rounded-lg h-full pb-4">
      <div className="px-3 py-2 text-primary font-bold text text-xs">
        State Appointed
      </div>
      {stateAppointeds.length > 0 &&
        stateAppointeds.map((state, i) => {
          return (
            <div key={i}>
              <CarrierStateAppointedForm stateAppointed={state} />
            </div>
          );
        })}
    </div>
  );
};

export default CarrierStateAppointed;
